import React, { useEffect } from "react";
import { Button } from "~/components/Button";
import { MultiSelectInput } from "~/components/Controls/Select";
import { Progress } from "~/components/Progress";
import { Intent } from "~/lib/intent";
import { Charts } from "~/modules/Dashboard/components/Charts";
import { PerformanceTable } from "~/modules/Dashboard/components/PerformanceTable";
import { DateRangePickerInput } from "~/components/Controls/DatePicker";
import { SelectInput } from "~/components/Controls/Select";
import { granularities } from "~/modules/Dashboard/models/Performance";
import { getGranularityDateFormat } from "~/modules/Dashboard/lib/performance";
import { lastDaysDateRange, lastMonthDateRange, todayDateRange, todayMonthDateRange, yesterdayDateRange } from "~/lib/date";
import { useDashboardReducer } from "~/modules/Dashboard/reducer";
import style from "./index.module.scss";

export function AdTypesPerformanceView() {
  const {
    state: { query, isDataPending, isFeaturePending, isDimensionsPending, dimensions },
    fetchData,
    fetchDimensions,
    setDimensions,
    setGranularity,
    setDateRange,
  } = useDashboardReducer();

  useEffect(() => {
    fetchDimensions();
  }, [query.from, query.to, query.granularity]);

  return (
    <div className={style.performanceView}>
      <div className="layout-content-box">
        <div className={style.dimensionFilter}>
          <SelectInput
            className={style.granularitySelect}
            placeholder="Granularity"
            value={query.granularity}
            items={granularities}
            onChange={setGranularity}
            disabled={isDataPending || isDimensionsPending || isFeaturePending}
          />
          <DateRangePickerInput
            dateRange={{startDate: query.from, endDate: query.to}}
            disabled={isDataPending || isDimensionsPending || isFeaturePending}
            onChange={setDateRange}
            ranges={[
              { label: "Today", onChoose: () => todayDateRange() },
              { label: "Yesterday", onChoose: () => yesterdayDateRange() },
              { label: "Last 7 days", onChoose: () => lastDaysDateRange(7) },
              { label: "Last 30 days", onChoose: () => lastDaysDateRange(30) },
              { label: "Last 60 days", onChoose: () => lastDaysDateRange(60) },
              { label: "This month", onChoose: () => todayMonthDateRange() },
              { label: "Last month", onChoose: () => lastMonthDateRange() },
              { label: "Last 90 days", onChoose: () => lastDaysDateRange(90) },
            ]}
          />
          <MultiSelectInput
            value={query.dimensions}
            searchable
            placeholder="types..."
            disabled={isDimensionsPending || isDataPending}
            onChange={setDimensions}
            items={dimensions}
          />
          <Button
            disabled={isDimensionsPending || isDataPending}
            onClick={() => fetchData()}
            leftIcon={<i className="fa fa-check" />}
            intent={Intent.PRIMARY}
          >
            Apply
          </Button>
        </div>
        {isDataPending ? (
          <Progress />
        ) : (
          <>
            <Charts />
            <PerformanceTable />
          </>
        )}
      </div>
    </div>
  );
}
